import { render, staticRenderFns } from "./EnPrivacyPolicy.vue?vue&type=template&id=f943e93a&scoped=true"
import script from "./EnPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./EnPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f943e93a",
  null
  ,true
)

export default component.exports